const config = {
                  apiUrl: 'https://klinkerapp.dobetterthings.de/api',
                  appUrl: 'https://klinkerapp.dobetterthings.de',
                  
                  project: { id: null, data: { name: '', desc:'', products:[] }, access: [] },
                  
                  product: {
                    colors: [
                                  { id: 'wht', name: "Weiß/Grau" },
                                  { id: 'yllw', name: "Gelb/Beige" },
                                  { id: 'brwn', name: "Rot/Braun" },
                                  { id: 'blck', name: "Schwarz/Anthrazit" },
                                ],
                    properties: [
                      { id: 'format', name: 'Format', type: 'radio', values: [
                                                                          { id: 'nf', name: 'Normalformat NF' },
                                                                          { id: 'lf', name: 'Lanformat LF' },
                                                                          { id: 'df', name: 'Dünnformat DF' },
                                                                          { id: 'wf', name: 'Waalformat WF' },
                                                                          { id: 'wdf', name: 'Waaldikformat WDF' },
                                                                          { id: 'of', name: 'Oldenburger Format OF' },
                                                                          { id: 'rf', name: 'Reichsformat RF' },
                                                                          { id: '2df', name: '2DF' },
                                                                          { id: 'fm', name: 'Fomratmix' },
                                                                          { id: 'sf', name: 'Sonderformat' },
                                                                          ]},
                       { id: 'surface', name: 'Oberfläche', type: 'radio', values: [{ id: 'hf', name: 'Handform' }, { id:'stws', name:'Stranggezogen / Wasserstrich'}] },
                       { id: 'stonetype', name: 'Typ', type: 'checkbox', 
                              values:[
                                    { id: 'k', name: "Verblender/Klinker *" },
                                    { id: 'r', name: "Riemchen **" },
                                    ]
                        },
                    ] 

                  }
              }
export default config;